<app-autocomplete-select
  placeholder="{{'search.dossier' | translate}}"
  [options]="options"
  [(ngModel)]="value"
  style="width: 100%">
</app-autocomplete-select>
